module.exports = __webpack_public_path__ + "static/media/margate-1.38474340.jpg";